import * as t from "io-ts";
import { Metadata } from "./Metadata";

export const Referral = t.intersection([
  t.type({
    email: t.string,
    name: t.string,
  }),
  t.partial({
    mobile: t.string,
    from: t.string,
    cid: t.string,
    trading_name: t.string,
    lifecycle: t.string,
    billing: t.string,
    metadata: Metadata,
  }),
]);

export interface Referral {
  email: string;
  name: string;
  mobile?: string;
  from?: string;
  cid?: string;
  trading_name?: string;
  lifecycle?: string;
  billing?: string;
  metadata?: Metadata;
}
